import { render, staticRenderFns } from "./MocoSettings.vue?vue&type=template&id=08dbbe22&lang=pug"
import script from "./MocoSettings.vue?vue&type=script&lang=js"
export * from "./MocoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports